import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataService } from '../../services/data.service';
import { NmDatatableSettings } from '../../widgets/datatable/datatable.interface';

@Component({
	selector: 'users-page',
	templateUrl: './users.html',
	styleUrls: ['./users.css']
})
export class UsersPage {
	public constructor(
		private data: DataService
	) {
		this.data.user.list()
		.then(res => {
			let users = res.json();
			console.log(users);
			this.datatableSetting.data.next(users);
		});
	}

	public datatableSetting: NmDatatableSettings = {
		modelName: 'user',
		fields: [
			{ name: 'name', label: 'Name', sortable: true, searchable: true, width: '20%' },
			{ name: 'email', label: 'Email', sortable: false, searchable: false, width: '40%' },
			//{ name: 'type', label: 'Type', sortable: false, searchable: false, width: '20%' },
			//{ name: 'status', label: 'Status', sortable: false, searchable: false, width: '10%' },
		],
		actions: [
			//{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true },
			{ name: 'edit', icon: 'pencil', color: 'green', show: (id) => this.data.user.isAdmin || id==this.data.user.whoami().id },
			{ name: 'delete', icon: 'trash', color: 'red', show: (id) => this.data.user.isAdmin && id!=this.data.user.whoami().id },
		],
		data: new BehaviorSubject([]),
		dataMassage: (data: any[]) => {
			return data.map(v => {
				v.name = v.name || 'N/A';
				v.email = v.email || 'N/A';
				v.type = v.type || 'N/A';
				v.status = v.status || 'N/A';
				return v;
			});
		},
		// ajax: {
		// 	url: 'user/datatables'
		// },
		// ajaxDataMassage: (data: any[]) => {
		// 	console.log(data);
		// 	return data;
		// }
	};
}


// WEBPACK FOOTER //
// ./src/pages/users/users.ts